import { Lightning } from "@phosphor-icons/react";
import { statusLabels, statusColors } from "./constants";
import { formatDateIT } from "@/lib/formatDate";

export function PhasesView({ phases }) {
  if (phases.length === 0) {
    return <div className="text-center py-8 text-zinc-500 text-sm">Nessuna fase disponibile</div>;
  }
  return (
    <div className="space-y-3">
      {phases.map((phase) => {
        const completed = phase.status === "completata";
        return (
          <div
            key={phase.id}
            className={`rounded-xl p-4 transition-all ${
              completed
                ? "bg-[#0F0F0F] border border-[#1A1A1A] opacity-50"
                : "bg-[#171717] border border-[#262626]"
            }`}
            data-testid={`shared-phase-${phase.id}`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                  completed ? "bg-zinc-800/50" : "bg-[#007AFF]/15"
                }`}>
                  <Lightning size={16} weight="fill" className={completed ? "text-zinc-600" : "text-[#007AFF]"} />
                </div>
                <div>
                  <h4 className={`font-semibold text-sm ${completed ? "text-zinc-500" : "text-white"}`}>{phase.title}</h4>
                  {phase.description && <p className="text-[11px] text-zinc-500 mt-0.5">{phase.description}</p>}
                </div>
              </div>
              <span className={`px-2 py-1 rounded-full text-[10px] font-medium ${statusColors[phase.status] || "bg-zinc-700 text-zinc-300"}`}>
                {statusLabels[phase.status] || phase.status}
              </span>
            </div>
            {(phase.start_date || phase.end_date) && (
              <div className="flex gap-4 mt-3 text-[11px] text-zinc-500 pl-11">
                {phase.start_date && <span>Inizio: {formatDateIT(phase.start_date)}</span>}
                {phase.end_date && <span>Fine: {formatDateIT(phase.end_date)}</span>}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
